import { DashboardTileProps, ExtensionSlot } from 'piral'
import * as React from 'react'

export default function DashboardTile(props: DashboardTileProps) {
    return (
        <ExtensionSlot name='layout-dashboard-tile' params={props}></ExtensionSlot>
    )
}
